module.exports = __webpack_public_path__ + "img/41.7fc689af.png";